import { render, staticRenderFns } from "./ListTvItems.vue?vue&type=template&id=520fd47f&scoped=true&"
import script from "./ListTvItems.vue?vue&type=script&lang=js&"
export * from "./ListTvItems.vue?vue&type=script&lang=js&"
import style0 from "./ListTvItems.vue?vue&type=style&index=0&id=520fd47f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520fd47f",
  null
  
)

export default component.exports